import {useIntl} from 'react-intl'
import {MenuItem} from './MenuItem'

export function MenuInner() {
  const intl = useIntl()
  return (
    <>
      <MenuItem title={intl.formatMessage({id: 'MENU.HOME'})} to='/' icon='home-2' />
      <MenuItem title={intl.formatMessage({id: 'MENU.BLOG'})} to='/mag/' icon='feather' reloadDocument />
      <MenuItem title={intl.formatMessage({id: 'MENU.ABOUT'})} to='/about' icon='people' />
      <MenuItem title={intl.formatMessage({id: 'MENU.CONTACT'})} to='/contact' icon='route' />
    </>
  )
}
